import { Box, Grid } from '@mui/material';

import { AccountItem } from './account-item';
import { PaginationControl } from 'src/components/pagination-buttons/pagination-control.component';
import { IPublicAccountItem } from 'src/types';

interface IProps {
  accounts: IPublicAccountItem[];
  withPagination?: boolean;
}

export const AccountsListComponent = ({ accounts, withPagination }: IProps) => {
  return (
    <Box id="index__components-home-accounts-list__box__l14"
    sx={{
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px'
    }}>
      
      {withPagination && accounts?.length > 0 &&
      <PaginationControl containerStyles={{ justifyContent: 'center' }} />
      }
      <Grid id="index__components-home-accounts-list__grid__l27" container spacing={3} sx={{ width: '100%', boxSizing: 'border-box' }}>
        {accounts.map((account) =>
        <Grid id="index__components-home-accounts-list__grid__l29"
        sx={{ width: '100%', boxSizing: 'border-box' }}
        item
        xs={6}
        sm={4}
        md={3}
        key={account.simple_id}>
          
            <AccountItem account={account} />
          </Grid>
        )}
      </Grid>
      {withPagination && accounts?.length > 0 &&
      <PaginationControl containerStyles={{ justifyContent: 'center' }} />
      }
    </Box>);

};